module.exports = __webpack_public_path__ + "static/icons/icon-9-day-a760238881b09efdc2204d38e7c314cf.svg";